// extracted by mini-css-extract-plugin
export default {"oldBrowser":"oldBrowser_oldBrowser__fmaQp","inner":"oldBrowser_inner__zxoKv"};